export { default } from './PriceCardsView';



// WEBPACK FOOTER //
// ./src/components/views/PriceCardsView/index.js